import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project-imports
import MainLayout from 'layout_vms/mainlayout_vms';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard_vms/AuthGuard';
// import CommonLayout from 'layout_vms/commonlayout_vms';
import { RoleGuard } from 'utils/route-guard_vms/RouteGuard';

const UnifiedDashboard = Loadable(lazy(() => import('pages_vms/dashboard_vms/UnifiedDashboard')));
const Visitors = Loadable(lazy(() => import('pages_vms/visitor_vms/Vistors_vms')));
const Projects = Loadable(lazy(() => import('pages_vms/projects_vms/projects_vms')));
const Reports = Loadable(lazy(() => import('pages_vms/reports_vms/reports_vms')));
const UserManagement = Loadable(lazy(() => import('pages_vms/user_management_vms/user_management_vms')));
const Manager = Loadable(lazy(() => import('pages_vms/assign_managers/Manager')));

const Logs = Loadable(lazy(() => import('pages_vms/logs_vms/logs_vms')));
const ViewReports = Loadable(lazy(() => import('pages_vms/reports_vms/reportsView')));
const VisitorDetailsView = Loadable(lazy(() => import('pages_vms/visitor_vms/VisitorDetailsView')));
const Viewproject = Loadable(lazy(() => import('pages_vms/projects_vms/Viewproject')));
const ViewUser = Loadable(lazy(() => import('pages_vms/user_management_vms/ViewUser')));
const AddUser = Loadable(lazy(() => import('pages_vms/user_management_vms/AddUser')));

const VisitorHistoryReport = Loadable(lazy(() => import('pages_vms/reports_vms/VisitorHistoryReport')));
// const AnticipatedReport = Loadable(lazy(() => import('pages_vms/reports_vms/ProjectReports')));
const CrossSelling = Loadable(lazy(() => import('pages_vms/reports_vms/CrossSellingReport')));
const ProjectReports = Loadable(lazy(() => import('pages_vms/reports_vms/ProjectReports')));
const VisitorbySource = Loadable(lazy(() => import('pages_vms/reports_vms/VisitorbySource')));
const CPbySource = Loadable(lazy(() => import('pages_vms/reports_vms/CPbySource')));
const ScheduleVisit = Loadable(lazy(() => import('pages_vms/reports_vms/ScheduleVisit')));
const SMPerformance = Loadable(lazy(() => import('pages_vms/reports_vms/SMPerformance')));

const ViewManager = Loadable(lazy(() => import('pages_vms/assign_managers/ViewManager')));
const GenerateOTP = Loadable(lazy(() => import('pages_vms/generateOTP/generateopt')));
const Settings = Loadable(lazy(() => import('pages_vms/settings/settings')));
const Enterdetails = Loadable(lazy(() => import('pages_vms/generateOTP/Enterdetails')));
const VisitorDetails = Loadable(lazy(() => import('pages_vms/generateOTP/VisitorInformation')));
// const Checkin = Loadable(lazy(() => import('pages_vms/check_in/Check_in')));
const Checkin = Loadable(lazy(() => import('pages_vms/check_in/CheckInType')));
// const CustomerDetails = Loadable(lazy(() => import('pages_vms/check_in/CustomerDetails')));
const CustomerDetails = Loadable(lazy(() => import('pages_vms/check_in/CustomerDetailsUI')));
const FrontDeskSummary = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/FrontDeskSummary')));
const FrontDeskSummaryView = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/FrontDeskSummaryView')));
const DepartmentSummary = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/DepartmentSummary')));
const DepartmentView = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/DepartmentView')));
const DepartmentCreate = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/DepartmentCreate')));
const EmployeeSummary = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/EmployeeSummary')));
const EmployeeView = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/EmployeeView')));
const EmployeeCreate = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/EmployeeCreate')));
// const PurposeofvisitSummary = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/PurposeofvisitSummary')));
const FrontdeskCheckIn = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/FrontdeskCheckIn')));
const FrontdeskOtpVerify = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/FrontdeskOtpVerify')));
const FrontdeskVisitorEntry = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/VisitorCheckIn')));
const FrontdeskCourierEntryPage = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/FrontdeskCourierEntryPage')));
const AddManager = Loadable(lazy(() => import('pages_vms/assign_managers/AddManager')));
const ExpectedVisitors = Loadable(lazy(() => import('pages_vms/reports_vms/expectedVisitors')));
const TodayExpectedVisitors = Loadable(lazy(() => import('pages_vms/reports_vms/todayexpected')));
const CustomerWaitingList = Loadable(lazy(() => import('pages_vms/sales_manager/CustomerWaitinglist')));
// const SMAssignedList = Loadable(lazy(() => import('pages_vms/sales_manager/SMAssignedList')));
const SMAssignedList = Loadable(lazy(() => import('pages_vms/Gre/GRECustomerList')));
const SMWaitingList = Loadable(lazy(() => import('pages_vms/sales_manager/SMWaitingList')));
const SMAssignedView = Loadable(lazy(() => import('pages_vms/sales_manager/SMAssignedView')));
const SMWaitingView = Loadable(lazy(() => import('pages_vms/sales_manager/SMWaitingView')));
const GREDashboard = Loadable(lazy(() => import('pages_vms/Gre/Dashboard')));
const GRECustomerlist = Loadable(lazy(() => import('pages_vms/Gre/GRECustomerList')));
const GRESMAssignedList = Loadable(lazy(() => import('pages_vms/Gre/GREAssignedList')));
const GRECustomerView = Loadable(lazy(() => import('pages_vms/Gre/GRECustomerView')));
const FormHome = Loadable(lazy(() => import('pages_vms/FormStatus/FormHome')));
const PermissionRole = Loadable(lazy(() => import('utils/route-guard_vms/PermissionGuard')));
const RolePermission = Loadable(lazy(() => import('pages_vms/user_management_vms/RolePermission')));
const RoleSummary = Loadable(lazy(() => import('pages_vms/user_management_vms/RoleSummary')));
const UserLogs = Loadable(lazy(() => import('pages_vms/user_management_vms/UserLogs')));
const AddRole = Loadable(lazy(() => import('pages_vms/user_management_vms/AddRole')));
const VendorList = Loadable(lazy(() => import('pages_vms/VendorList')));
const VendorView = Loadable(lazy(() => import('pages_vms/VendorView')));
const InterestList = Loadable(lazy(() => import('pages_vms/InterestList')));
const InterestView = Loadable(lazy(() => import('pages_vms/InterestView')));
const SourceList = Loadable(lazy(() => import('pages_vms/reports_vms/SourceList')));


const OfficeMaster = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/OfficeSummary')));
const OfficeCreate = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/OfficeCreate')));
const OfficeView = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/OfficeView')));
const PurposeofvisitSummary = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/PurposeofvisitSummary')));
const PurposeofCreate = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/PurposeofCreate')));
const PurposeofVisitView = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/PurposeofVisitView')));
const IDProofSummary = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/IDProofSummary')));
const IDProofCreate = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/IDProofCreate')));
const IDProofView = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/master/IDProofView')));

const VisitorReport = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/reports/VisitorReport')));
const VisitorLocation = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/reports/LocationReport')));
const VisitorDepartment = Loadable(lazy(() => import('pages_vms/check_in/frontdesk/reports/DepartmentReport')));


const MainRoutes_VMS = {
  path: 'vms/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      // Single dashboard entry point for every role — see UnifiedDashboard.jsx. It composes the
      // previously-separate per-role dashboards as sections, each individually gated by
      // PermissionRole (module/permission), so which sections render depends on the logged-in
      // user's actual permissions instead of a hardcoded role check.
      path: 'dashboard',
      // UnifiedDashboard already falls back to DashboardHome for any role not explicitly listed in
      // its SECTION_BY_ROLE map (Sales Manager/Sales Head/Admin/GRE) — which includes Receptionist,
      // so this covers the developmentV2-frontdesk branch's RoleGuard-gated DashboardHome route too.
      element: <UnifiedDashboard />
    },
    {
      path: 'generateotp',
      element: <GenerateOTP />
    },
    {
      path: 'settings',
      element: <Settings />
    },
    {
      path: 'enterdetails',
      element: <Enterdetails />
    },
    {
      path: 'visitor',
      element: <VisitorDetails />
    },
    {
      path: 'checkin',
      element: <Checkin />
    },
    {
      path: 'visitordetails',
      element: <CustomerDetails />
    },
    {
      // Dedicated Receptionist Visitor Entry / Courier flow — each phase (category+OTP-send, OTP
      // verify, the 4-step wizard, courier) gets its own path instead of all sharing /vms/checkin,
      // so refreshing mid-flow (e.g. on wizard step 4) stays on that same step. See
      // frontdeskSession.js for how progress is persisted across a refresh.
      // No PermissionGuard here — matches the /vms/checkin route above and the rest of the
      // frontdesk feature set, since Receptionist's real backend permissions aren't finalized yet.
      path: 'checkin/frontdesk',
      element: <FrontdeskCheckIn />
    },
    {
      path: 'checkin/frontdesk/otp',
      element: <FrontdeskOtpVerify />
    },
    {
      path: 'checkin/frontdesk/visitor/:step',
      element: <FrontdeskVisitorEntry />
    },
    {
      path: 'checkin/frontdesk/courier',
      element: <FrontdeskCourierEntryPage />
    },
    {
      // No PermissionGuard here — matches the /vms/checkin route above and the rest of the
      // frontdesk feature set, since Receptionist's real backend permissions aren't finalized yet.
      path: 'checkin/frontdesk/summary',
      element: <FrontDeskSummary />
    },
    {
      path: 'checkin/frontdesk/summary/:entryId',
      element: <FrontDeskSummaryView />
    },
    {
      path: 'master/departments',
      element: <DepartmentSummary />
    },
    {
      path: 'master/departments/create',
      element: <DepartmentCreate />
    },
    {
      path: 'master/departments/:id',
      element: <DepartmentView />
    },
    {
      path: 'master/employees',
      element: <EmployeeSummary />
    },
    {
      path: 'master/employees/create',
      element: <EmployeeCreate />
    },
    {
      path: 'master/employees/:id',
      element: <EmployeeView />
    },
    {
      path: 'master/office',
      element: <OfficeMaster />
    },
    {
      path: 'master/office/create',
      element: <OfficeCreate />
    },
    {
      path: 'master/office/:id',
      element: <OfficeView />
    },
    {
      path: 'master/purpose-of-visit',
      element: <PurposeofvisitSummary />
    },
    {
      path: 'master/purpose-of-visit/create',
      element: <PurposeofCreate />
    },
    {
      path: 'master/purpose-of-visit/:id',
      element: <PurposeofVisitView />
    },
    {
      path: 'master/id-proof',
      element: <IDProofSummary />
    },
    {
      path: 'master/id-proof/create',
      element: <IDProofCreate />
    },
    {
      path: 'master/id-proof/:id',
      element: <IDProofView />
    },
    {
      path: 'report/visitor',
      element: <VisitorReport />
    },
    {
      path: 'report/location',
      element: <VisitorLocation />
    },
    {
      path: 'report/department',
      element: <VisitorDepartment />
    },
    {
      path: 'visitors',
      module: 'visitors',
      children: [
        {
          path: 'home',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'Security', 'GRE']}>
            //   <Visitors />
            // </RoleGuard>
            <PermissionRole module="visitors" permission='list'>
              <Visitors />
            </PermissionRole>
          )
        },
        {
          path: 'view',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'Security', 'GRE']}>
            //   <ViewVisitors />
            // </RoleGuard>
            <PermissionRole module="visitors" permission='view'>
              <VisitorDetailsView />
            </PermissionRole>
          )
        },
        {
          path: 'view/:id',
          element: (
            // Shared with the consolidated /vms/visitorlist — gated the same way (customer/summary
            // permission) so a Sales Manager landing on that list can still open a row's details.
            <PermissionRole module="customer" permission="summary">
              <GRECustomerView />
            </PermissionRole>
          )
        },
        {
          path: 'visitorview/:id',
          element: (
            // <RoleGuard allowedRoles={['Sales Manager']}>
            //   <SMAssignedView />
            // </RoleGuard>
            <PermissionRole module="customer" permission="summary">
              <SMAssignedView />
            </PermissionRole>
          )
        },
        {
          path: 'waitinglist',
          element: (
            // <RoleGuard allowedRoles={['Sales Manager']}>
            //   <SMWaitingList />
            // </RoleGuard>
            <PermissionRole module="customer" permission='waiting list'>
              <SMWaitingList />
            </PermissionRole>
          )
        },
      ]
    },
    {
      path: 'projects',
      module: 'projects',
      children: [
        {
          path: 'home',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <Projects />
            // </RoleGuard>
            <PermissionRole module="projects" permission='list'>
              <Projects />
            </PermissionRole>
          )

        },
        {
          path: 'view',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <Viewproject />
            // </RoleGuard>
            <PermissionRole module="projects" permission='view'>
              <Viewproject />
            </PermissionRole>
          )
        }
      ]
    },
    {
      path: 'master',
      children: [
        {
          path: 'vendor',
          element: <VendorList />
        },
        {
          path: 'vendor/view/:id',
          element: <VendorView />
        },
        {
          path: 'interest',
          element: <InterestList />
        },
        {
          path: 'interest/view/:id',
          element: <InterestView />
        },
        {
          path: 'source',
          element: <SourceList />
        },
      ]
    },
    {
      path: 'reports',
      children: [
        {
          path: 'home',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'Sales Head', 'GRE']}>
            //   <Reports />
            // </RoleGuard>
            <PermissionRole module="reports" permission='project reports'>
              <Reports />
            </PermissionRole>
          )
        },
        {
          path: 'view',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <ViewReports />
            // </RoleGuard>
            <PermissionRole module="reports" permission='view'>
              <ViewReports />
            </PermissionRole>
          )
        },
        {
          path: 'expected',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <ExpectedVisitors />
            // </RoleGuard>
            <PermissionRole module="reports" permission="tomorrow's anticipated">
              <ExpectedVisitors />
            </PermissionRole>
          )
        },
        {
          path: 'todayexpected',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <TodayExpectedVisitors />
            // </RoleGuard>
            <PermissionRole module="reports" permission="today's expected visitors">
              <TodayExpectedVisitors />
            </PermissionRole>
          )
        },
        {
          path: 'FormStatus',
          element: (
            // <RoleGuard allowedRoles={['Admin']}>
            //   <FormHome />
            // </RoleGuard>
            <PermissionRole module="reports" permission='walk-in form'>
              <FormHome />
            </PermissionRole>
          )
        },

        {
          path: 'visitorhistory',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <VisitorHistoryReport />
            // </RoleGuard>
            <PermissionRole module='report' permission='visitor history'>
              <VisitorHistoryReport />
            </PermissionRole>
          )
        },
        {
          path: 'projectreport',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <ProjectReports />
            // </RoleGuard>
            <PermissionRole module='report' permission='project'>
              <ProjectReports />
            </PermissionRole>
          )
        },
        {
          path: 'cross-selling',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <CrossSelling />
            // </RoleGuard>
            <PermissionRole module='report' permission='cross selling'>
              <CrossSelling />
            </PermissionRole>
          )
        },
        {
          path: 'visitorsource',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <CrossSelling />
            // </RoleGuard>
            <PermissionRole module='report' permission='visitors by source'>
              <VisitorbySource />
            </PermissionRole>
          )
        },
        {
          path: 'cp-source',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
            //   <CrossSelling />
            // </RoleGuard>
            <PermissionRole module='report' permission='visitors by cp'>
              <CPbySource />
            </PermissionRole>
          )
        },
        {
          path: 'schedule-visit',
          element: (
            <PermissionRole module='report' permission='schedule visit'>
              <ScheduleVisit />
            </PermissionRole>
          )
        },
        {
          path: 'sm-performance',
          element: (
            <PermissionRole module='report' permission='sm performance'>
              <SMPerformance />
            </PermissionRole>
          )
        },
      ]
    },

    {
      path: 'usermanagement',
      children: [
        {
          path: 'home',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'GRE']}>
            //   <UserManagement />
            // </RoleGuard>
            <PermissionRole module="user" permission='summary'>
              <UserManagement />
            </PermissionRole>
          )
        },
        {
          path: 'view',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'GRE']}>
            //   <ViewUser />
            // </RoleGuard>
            <PermissionRole module="user" permission='summary'>
              <ViewUser />
            </PermissionRole>
          )
        },
        {
          // id now travels in the URL (e.g. /vms/usermanagement/view/123) instead of only via
          // route state, so a refresh or a shared/bookmarked link still resolves the user.
          path: 'view/:id',
          element: (
            <PermissionRole module="user" permission='summary'>
              <ViewUser />
            </PermissionRole>
          )
        },
        {
          path: 'adduser',
          element: (
            // <RoleGuard allowedRoles={['Admin']}>
            //   <AddUser />
            // </RoleGuard>
            <PermissionRole module="user" permission='create'>
              <AddUser />
            </PermissionRole>
          )
        },
        {
          path: 'addRole',
          element: (
            // <RoleGuard allowedRoles={['Admin']}>
            //   <AddUser />
            // </RoleGuard>
            <PermissionRole module="role" permission='create'>
              <AddRole />
            </PermissionRole>
          )
        },
        {
          path: 'rolepermission',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Security', 'Store Manager', 'Head Stores']}>
            //   <UserList />
            // </RoleGuard>
            <PermissionRole module="role" permission='permissions'>
              <RolePermission />
            </PermissionRole>
          )

        },
        {
          path: 'rolesummary',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Security', 'Store Manager', 'Head Stores']}>
            //   <UserList />
            // </RoleGuard>
            <PermissionRole module="role" permission='summary'>
              <RoleSummary />
            </PermissionRole>
          )

        },
        {
          path: 'userlog',
          element: (
            // <RoleGuard allowedRoles={['Admin', 'Security', 'Store Manager', 'Head Stores']}>
            //   <UserList />
            // </RoleGuard>
            <PermissionRole module="user" permission='summary'>
              <UserLogs />
            </PermissionRole>
          )

        },
      ]
    },
    {
      // Single shared "Visitor Summary" list for GRE and Sales Manager alike — gated purely on the
      // customer/summary permission so it isn't tied to (and duplicated under) either role's own
      // path prefix. Replaces the separate gre/customerlist and salesManager/assignedlist routes.
      path: 'visitorlist',
      element: (
        <PermissionRole module="customer" permission="summary">
          <GRECustomerlist />
        </PermissionRole>
      )
    },
    {
      path: 'salesManager',
      children: [
        {
          path: 'home',
          element: (
            <RoleGuard allowedRoles={['Sales Manager']}>
              <CustomerWaitingList />
            </RoleGuard>
          )
        },
        {
          // Folded into the unified /vms/dashboard as a permission-gated section — kept as a
          // redirect so any existing bookmark/nav-item pointing here still lands somewhere real.
          path: 'dashboard',
          element: <Navigate to="/vms/dashboard" replace />
        },
        {
          path: 'assignedlist',
          element: (
            // <RoleGuard allowedRoles={['Sales Manager']}>
            //   <SMAssignedList />
            // </RoleGuard>
            <PermissionRole module="customer" permission='summary'>
              <SMAssignedList />
            </PermissionRole>
          )
        },
        // {
        //   path: 'waitinglist',
        //   element: (
        //     // <RoleGuard allowedRoles={['Sales Manager']}>
        //     //   <SMWaitingList />
        //     // </RoleGuard>
        //     <PermissionRole module="customer" permission='waiting list'>
        //       <SMWaitingList />
        //     </PermissionRole>
        //   )
        // },
        {
          path: 'assignedview/:id',
          element: (
            <RoleGuard allowedRoles={['Sales Manager']}>
              <SMAssignedView />
            </RoleGuard>
          )
        },
        {
          path: 'waitingview/:id',
          element: (
            // <RoleGuard allowedRoles={['Sales Manager']}>
            //   <SMWaitingView />
            // </RoleGuard>
            <PermissionRole module="customer" permission='waiting list'>
              <SMWaitingView />
            </PermissionRole>
          )
        }
      ]
    },
    {
      path: 'gre',
      children: [
        {
          // GRE's worklist (reassignment table) — kept as its own page, not folded into the
          // unified dashboard, since it's a distinct destination from the KPI-style dashboards.
          // Permission-gated instead of the old RoleGuard allowedRoles={['GRE']}.
          path: 'home',
          element: (
            <PermissionRole module="sm active" permission={['assign summary', 'add sm']}>
              <GREDashboard />
            </PermissionRole>
          )
        },
        {
          path: 'customerlist',
          element: (
            <PermissionRole module="customer" permission='summary'>
              <GRECustomerlist />
            </PermissionRole>
          )
        },
        {
          path: 'smassign',
          element: (
            // <RoleGuard allowedRoles={['GRE', 'Admin']}>
            //   <GRESMAssignedList />
            // </RoleGuard>
              <PermissionRole module="sm active" permission={['assign summary', 'add sm']}>
              <GRESMAssignedList />
            </PermissionRole>
          )
        },
        // {
        //   path: 'view/:id',
        //   element: (
        //     // Shared with the consolidated /vms/visitorlist — gated the same way (customer/summary
        //     // permission) so a Sales Manager landing on that list can still open a row's details.
        //     <PermissionRole module="customer" permission="summary">
        //       <GRECustomerView />
        //     </PermissionRole>
        //   )
        // },
        {
          // Folded into the unified /vms/dashboard as a permission-gated section.
          path: 'dashboard',
          element: <Navigate to="/vms/dashboard" replace />
        }
      ]
    },
    {
      path: 'salesHead',
      children: [
        {
          path: 'home',
          element: (
            <RoleGuard allowedRoles={['Sales Head']}>
              <Manager />
            </RoleGuard>
          )
        },
        {
          // Folded into the unified /vms/dashboard as a permission-gated section.
          path: 'dashboard',
          element: <Navigate to="/vms/dashboard" replace />
        },
        {
          path: 'view',
          element: (
            <RoleGuard allowedRoles={['Sales Head']}>
              <ViewManager />
            </RoleGuard>
          )
        },
        {
          path: 'addmanager',
          element: (
            <RoleGuard allowedRoles={['Sales Head']}>
              <AddManager />
            </RoleGuard>
          )
        }
      ]
    },
    {
      path: 'admin',
      children: [

        {
          // Folded into the unified /vms/dashboard as a permission-gated section.
          path: 'dashboard',
          element: <Navigate to="/vms/dashboard" replace />
        },

      ]
    },
    {
      path: 'logs',
      element: (
        <RoleGuard allowedRoles={['Admin', 'Sales Manager', 'Sales Head', 'GRE']}>
          <Logs />
        </RoleGuard>
      )
    }
  ]
};

export default MainRoutes_VMS;
